import axios from 'axios'
import store from '@/store/index'

const homebaseClient = axios.create({
    baseURL: store.state.homebaseApiUrl,
    timeout: 15000
})

homebaseClient.interceptors.request.use((config) => {
    config.headers = config.headers || {}
    config.headers['x-api-key'] = store.state.homebaseApiKey
    config.headers['Content-Type'] = 'application/json'
    try {
        const url = `${config.baseURL || ''}${config.url || ''}`
        console.log('[HomeBase] Request:', config.method?.toUpperCase(), url)
        console.log('[HomeBase] Headers:', config.headers)
        console.log('[HomeBase] API Key:', store.state.homebaseApiKey)
    } catch (_) { }
    return config
})

homebaseClient.interceptors.response.use(
    (response) => {
        try {
            const url = `${response.config.baseURL || ''}${response.config.url || ''}`
            console.log('[HomeBase] Response:', response.status, url)
        } catch (_) { }
        return response
    },
    (error) => {
        try {
            const url = `${error.config?.baseURL || ''}${error.config?.url || ''}`
            console.warn('[HomeBase] Error:', error.response?.status, url)
        } catch (_) { }
        const normalized = {
            status: error.response?.status,
            detail: error.response?.data?.detail || error.message
        }
        return Promise.reject(normalized)
    }
)

export default homebaseClient


